// EventRepository.js
class EventRepository {
    constructor() {
        // Base URL for your API - change this to your deployed server URL
        //this.apiUrl = 'http://147.93.95.186:5000/api'; // Default for local development
        this.apiUrl = 'https://server.unitesainteveronique.com/api'; // Default for local development
    }

    // Set the API URL (useful for different environments)
    setApiUrl(url) {
        this.apiUrl = url;
    }

    async getEventBySection(idSection) {
        try {
            const response = await fetch(`${this.apiUrl}/events/section/${idSection}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch events: ${response.statusText}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Error fetching events by section ID:', error);
            throw error;
        }
    }

    async getEventById(id) {
        try {
            const response = await fetch(`${this.apiUrl}/events/${id}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch event: ${response.statusText}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching event by ID:', error);
            throw error;
        }
    }

    async updateEvent(id, updatedEvent) {
        // Validate input
        if (!id) {
            throw new Error("Invalid ID provided for event update");
        }

        if (!updatedEvent.nom || !updatedEvent.date_debut || !updatedEvent.date_fin) {
            throw new Error("Missing required event properties");
        }

        try {
            const response = await fetch(`${this.apiUrl}/events/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedEvent),
            });

            if (!response.ok) {
                throw new Error(`Failed to update event: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error updating event:', error);
            throw error;
        }
    }

    async createEvent(event) {
        // Validate input
        if (!event.nom || !event.date_debut || !event.date_fin || !event.sectionId) {
            throw new Error("Missing required event properties");
        }

        try {
            const response = await fetch(`${this.apiUrl}/events`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(event),
            });

            if (!response.ok) {
                throw new Error(`Failed to create event: ${response.statusText}`);
            }

            const result = await response.json();
            return result.insertId;
        } catch (error) {
            console.error('Error creating event:', error);
            throw error;
        }
    }

    async deleteEvent(id) {
        try {
            const response = await fetch(`${this.apiUrl}/events/${id}`, {
                method: 'DELETE',
            });

            if (!response.ok) {
                throw new Error(`Failed to delete event: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error deleting event:', error);
            throw error;
        }
    }
}

export default EventRepository;